import { VISORIA_STORE_IMAGES } from "../../images/visoria";

export const MAX_OTHER_STORE_QUANTITY = 10;

export function attachStoreImage(store) {
  if (!store) {
    return null;
  }
  return {
    ...store,
    image: VISORIA_STORE_IMAGES[store.id] ?? null,
  };
}

export function attachStoreListImages(stores) {
  return stores.map((store) => attachStoreImage(store));
}

export function getMaxPurchasableQuantity(stockAvailable) {
  if (!Number.isFinite(stockAvailable) || stockAvailable <= 0) {
    return 0;
  }
  return Math.min(MAX_OTHER_STORE_QUANTITY, stockAvailable);
}

export function formatRubPrice(amount) {
  return `${Math.round(amount).toLocaleString("ru-RU")} ₽`;
}

export function formatUsdtPrice(amount) {
  const value = Number(amount);
  if (!Number.isFinite(value)) {
    return "— USDT";
  }
  return `${value.toLocaleString("en-US", {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  })} USDT`;
}

export async function copyTextToClipboard(text) {
  const value = String(text || "");
  if (!value) {
    return false;
  }

  try {
    if (navigator.clipboard?.writeText) {
      await navigator.clipboard.writeText(value);
      return true;
    }
  } catch {
    // Fallback below for HTTP or denied permissions.
  }

  try {
    const textArea = document.createElement("textarea");
    textArea.value = value;
    textArea.setAttribute("readonly", "");
    textArea.style.position = "fixed";
    textArea.style.left = "-9999px";
    document.body.appendChild(textArea);
    textArea.select();
    const copied = document.execCommand("copy");
    document.body.removeChild(textArea);
    return copied;
  } catch {
    return false;
  }
}
